import { CheckOutlined, CloseOutlined, EyeOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import {
  Pending,
  ReadyForReview,
  Rejected,
  Verified,
} from "../../../components/components/StatusIndicators";
import { Button, Image, Modal } from "antd";
import useGetFile from "../../../hooks/useGetFile";
import useAuthUserToken from "../../../hooks/useAuthUserToken";
import useAxios from "../../../hooks/useAxios";
import RejectModal from "../../Candidate/components/RejectModal";
import AIRemarks from "../Components/AIRemarks";

const PhotoSection = ({
  candidateDetails,
  getCandidateDetails,
  setLoading,
  aiRemarks,
  canAcceptReject
}) => {
  const api = useAxios();
  const { userToken } = useAuthUserToken();
  const { getImage } = useGetFile(userToken);
  const [photo, setPhoto] = useState("");
  const [viewPhoto, setViewPhoto] = useState(false);
  const [rejectModalPhoto, setRejectModalPhoto] = useState(false);
  const [imgRejectReason, setImgRejectReason] = useState("");

  const acceptPhoto = async (e) => {
    setLoading(true);
    try {
      await api.put(
        `/candidate/candidatePhotoStatus/${candidateDetails?._id}`,
        {
          Status: true,
        },
        { tokenType: "user" },
      );
      await getCandidateDetails();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const rejectPhoto = async (e) => {
    setLoading(true);
    try {
      const data = await api.put(
        `/candidate/candidatePhotoStatus/${candidateDetails?._id}`,
        {
          Status: false,
          candidatePhotoRejection: imgRejectReason,
        },
        { tokenType: "user" },
      );
      console.log(data.data);
      setImgRejectReason("");
      setRejectModalPhoto(false);
      await getCandidateDetails();
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const IS_REJECTED_PHOTO =
    candidateDetails?.candidatePhotoStatus !== null &&
    candidateDetails?.candidatePhotoStatus === false &&
    candidateDetails?.photoFilledStatus === false;

  const IS_VERIFIED_PHOTO = candidateDetails?.candidatePhotoStatus;

  return (
    <>
      <div
        style={{
          ...(IS_REJECTED_PHOTO ? { border: "1px solid red" } : {}),
          // ...(IS_VERIFIED_PHOTO ? { border: "1px solid #00AC1A" } : {}),
          position: "relative",
        }}
        className="card p-2 flex flex-row justify-between"
      >
        <div className="w-full">
          <div className="flex justify-between">
            <strong>Passport Photo : </strong>
            {
              candidateDetails?.candidatePhoto?.length !== 0 &&
              <AIRemarks aiRemarks={aiRemarks} docType={"Profile_Image"}/>
            }
          </div>
          <div className="flex mt-3 justify-between">
            <div>
              {canAcceptReject && (
                <>
                  <Button
                    disabled={
                      (candidateDetails?.candidatePhotoStatus &&
                        candidateDetails?.isEmpTempIdCreated) ||
                      candidateDetails?.candidatePhoto?.length === 0
                    }
                    title="accept"
                    shape="circle"
                    type="success"
                    size="small"
                    icon={<CheckOutlined />}
                    style={{ marginRight: "4px" }}
                    onClick={() => acceptPhoto()}
                  ></Button>
                  <Button
                    disabled={
                      (candidateDetails?.candidatePhotoStatus &&
                        candidateDetails?.isEmpTempIdCreated) ||
                      candidateDetails?.candidatePhoto?.length === 0
                    }
                    title="reject"
                    shape="circle"
                    type="danger"
                    size="small"
                    icon={<CloseOutlined />}
                    style={{ marginRight: "4px" }}
                    onClick={() => {
                      setRejectModalPhoto(true);
                    }}
                  ></Button>
                </>
              )}
              <Button
                title="view"
                shape="circle"
                type=""
                size="small"
                disabled={candidateDetails?.candidatePhoto?.length === 0}
                icon={<EyeOutlined />}
                onClick={async () => {
                  const img = await getImage(
                    candidateDetails?.candidatePhoto?.[0]?.path,
                  );
                  setPhoto(img);
                  setViewPhoto(true);
                }}
                style={{ marginRight: "4px" }}
              ></Button>
            </div>
            <div>
              {candidateDetails?.photoFilledStatus === false &&
              candidateDetails?.candidatePhotoStatus === null ? (
                <Pending />
              ) : (
                <>
                  {(candidateDetails?.candidatePhotoStatus === null ||
                    candidateDetails?.candidatePhotoStatus === false) &&
                  candidateDetails?.photoFilledStatus === true ? (
                    <ReadyForReview />
                  ) : (
                    <>
                      {candidateDetails?.candidatePhotoStatus ? (
                        <Verified />
                      ) : (
                        <>
                          <Rejected />
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>

        {IS_REJECTED_PHOTO && (
          <div
            className="d-flex gap-2 text-danger font-weight-bold"
            style={{ position: "absolute", bottom: -20, right: 0 }}
          >
            Reason : {candidateDetails?.candidatePhotoRejection}
          </div>
        )}
      </div>
      <Modal
        centered
        open={viewPhoto}
        onOk={(e) => setViewPhoto(!viewPhoto)}
        onCancel={(e) => setViewPhoto(!viewPhoto)}
        width={500}
        title="Passport Photo"
        footer={null}
      >
        <div className="d-flex justify-content-center p-4">
          {/* <div
                    className={`passport__photo mt-3 ${
                      candidateDetails?.candidatePhoto?.length !== 0
                        ? ""
                        : "passport__photo_active"
                    }`}
                  >
                    {candidateDetails?.candidatePhoto && (
                      <img
                        className="img"
                        src={
                          documentType === "S3" && BASE.storageType
                            ? s3Files?.candidatePhoto
                            : url() + candidateDetails?.candidatePhoto[0]?.path
                        }
                        alt="passport__photo"
                      />
                    )}
                  </div> */}
          <Image src={photo} />
        </div>
      </Modal>
      <RejectModal
        open={rejectModalPhoto}
        closeHandler={setRejectModalPhoto}
        value={imgRejectReason}
        setValue={setImgRejectReason}
        onSubmit={() => rejectPhoto()}
      />
    </>
  );
};

export default PhotoSection;
